"use client";

import styles from "./YellowCta.module.css";
import MaxWidth from "@/components/MaxWidth";
import { Button, Header3 } from "@bumble/ui-kit";
import { isExternalUrl } from "@/lib/utils/isExternalUrl";
interface Props {
  href: string;
}
export default function YellowCta({
  href
}: Props) {
  const isExternal = isExternalUrl(href);
  return <MaxWidth>
      <div className={styles.wrapper}>
        <div className={styles.yellow__cta}>
          <div className={styles.left}>
            <Header3>Ready to bring the world closer to love?</Header3>
          </div>
          <div className={styles.right}>
            <Button text="Get Started" href={href} isTargetBlank={isExternal} />
          </div>
        </div>
      </div>
    </MaxWidth>;
}